/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

import { Main } from "./component/Main"

import { Login } from "./component/Login"
import { Logout } from "./component/Logout"
import * as apiAuth from "./api/apiAuth"
import * as Auth from "./component/Login/Auth"
import './App.css';
import { SocketApp } from './component/SocketTest/SocketApp';
import { SocketWin } from './component/SocketTest/SocketWin';
//import { Loading } from './component/Loading';

export const AuthContext = React.createContext(null);

function App() {
  const [authState, setAuthState] = useState(Auth.isLogin());
  //const [isCheck, setIsCheck] = useState(false);
  const [url, setUrl] = useState("");
  var isCheck = false;


  //console.log("start APP")
  //console.log("isCheck init : "+isCheck)
  async function checkToken() {
    //console.log("authState : " + authState)
    //console.log("isCheck out : " + isCheck)
    var pathArray = window.location.pathname.split("/").slice(1)
    if (isSuperUrl(pathArray)) {
      console.log("A")
    } else {
      if (!authState || authState === "false") {
        if (!isCheck) {
          isCheck = true;
          var token = Auth.getToken();
          //console.log("token");
          //console.log(token);
          if (token === "null" || token === 'undefined' || token === "") {
            //console.log("token is null")
            isCheck = true;
            console.log(Auth.getTexIdNumber())
            console.log(isLoginUrl(pathArray))
            if (isLoginUrl(pathArray)) {
              var texIdNumber = Auth.getTexIdNumber();
              if (texIdNumber !== "") {
                texIdNumber = "/" + texIdNumber
              }
              setUrl(<Redirect to={'/login' + texIdNumber} />)
            }
            //setUrl(<Redirect to='/login' />)

            //console.log("toMain")
            //window.location.href = "/main";
          } else {
            console.log("token not null")
            await apiAuth.checkToken(token, (status) => {
              //console.log("checkToken");
              //console.log(status);
              setAuthState(status);
              Auth.setLogin(true);
              //console.log("isCheck in : "+isCheck)
              isCheck = true;
              if (!status) {
                setUrl(<Redirect to='/main' />)
              }
            });
          }
        } else {
          //setUrl(<Redirect to='/login' />)
          if (isLoginUrl(pathArray))
            setUrl(<Redirect to='/login' />)
        }
      } else {
        if (!isLoginUrl(pathArray))
          setUrl(<Redirect to='/main' />)
      }
    }
  }

  function isLoginUrl(pathArray) {
    //console.log(window.location.pathname)
    //console.log(pathArray[0])
    if (pathArray[0] !== "login" ) {
      return true
    }
    return false
  }


  function isSuperUrl(pathArray) {
    //console.log(window.location.pathname)
    //console.log(pathArray[0])
    switch (pathArray[0]) {
      case "socketApp":
      case "socketWin":
        return true
      default:
        return false
    }
  }



  useEffect(() => {
    checkToken();
  }, []);

  /*
  const RouteFallback = (props) => { 
    //console.log('route fallback with location: ', props.location); 
    if(props.match.path === "/"){
      if(authState === "true"){
        setUrl(<Redirect to='/main' />)
      }
    }
    return (
      <div></div>
    )
  }
  */

  return (
    <AuthContext.Provider value={[authState, setAuthState]}>
      <BrowserRouter>
        {/*console.log({url})*/}
        {url}
        <Switch>
          <Route path="/socketApp" name="SocketApp" component={SocketApp} />
          <Route path="/socketWin" name="SocketWin" component={SocketWin} />
          <Route path="/login" name="Login" component={Login} />
          <Route path="/logout" name="Main" component={Logout} />
          <Route path="/main" name="Main" component={Main} />
          {/*
        <Route path="/AdminPage" name="AdminPage" component={Main} />
        <Route path="/ManagerList" name="ManagerList" component={Main} />
        <Route path="/ManagerAdd" name="ManagerAdd" component={Main} />
        <Route path="/CompanyList" name="CompanyList" component={Main} />
        <Route path="/CompanyAdd" name="CompanyAdd" component={Main} />
        <Route path="/EmployeeList" name="EmployeeList" component={Main} />
         */}
          <Route component={Main} />  {/**非法路徑 */}
        </Switch>
      </BrowserRouter>
    </AuthContext.Provider>
  );
  /*
  if(!isTest){
    isTest = true;
    //window.location.replace("/login");
    // 跳轉到 Home 頁面
    return (
      <BrowserRouter>
        <Redirect to='/login' />
      </BrowserRouter>
    );
    //這樣寫也可以
    // return <Redirect to={{ pathname: "/" }} />;
  }else{
  }
  if(isLoading){
    return(
      <div id="loader">
      <CircularProgress className={classes.progress} />
      </div>
    )
  }else{
  }
  */
}

export default App;
